import { NumberInput, maxValue, minValue, required } from "react-admin";
import { MAX_SEMESTER } from "utils/constants";
import { integerValidator } from "utils/validations";
import GridItem from "./GridItem";

const SemesterInput = ({ source = "semester", label = "Семестър", md = 6, max = MAX_SEMESTER, helperText }) => (
  <GridItem md={md}>
    <NumberInput
      source={source}
      label={label}
      fullWidth
      min={1}
      max={max}
      step={1}
      helperText={helperText ?? `От 1 до ${max}`}
      validate={[
        required("Полето е задължително."),
        minValue(1, "Минималната стойност е 1."),
        maxValue(max, `Максималната стойност е ${max}.`),
        integerValidator,
      ]}
      onWheel={e => e.target.blur()}
    />
  </GridItem>
);

export default SemesterInput;
